import React, { useState, useEffect, useReducer } from 'react';
import {
  ENTERTAINMENT,
  entertainmentModules,
  guestRoomExpModules,
  GUEST_ROOM_EXP,
  hotelServiceModules,
  HOTEL_SERVICES,
  HOTEL_SYSTEMS_TITLES,
} from '../../../../constants/ConfigurationsConst';
import './../HotelSystems.scss';
import { Button, makeStyles } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import ModulesList from '../../../../components/modules-list/ModulesList';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    margin: '8px 18px',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    margin: '8px 18px',
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
    color: '#828282',
  },
  input: {
    display: 'none',
  },
}));

const ModuleSelect = (props) => {
  const { onLastNextClick } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(HOTEL_SERVICES);
  const [moduleList, setModuleList] = useState(hotelServiceModules);
  const [selectedModules, setSelectedModules] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      hotelServiceModules: [],
      guestRoomExpModules: [],
      entertainmentModules: [],
    },
  );

  useEffect(() => {
    switch (activeTab) {
      case HOTEL_SERVICES:
        setModuleList(hotelServiceModules);
        break;
      case GUEST_ROOM_EXP:
        setModuleList(guestRoomExpModules);
        break;

      case ENTERTAINMENT:
        setModuleList(entertainmentModules);
        break;

      default:
        setModuleList(hotelServiceModules);
    }
  }, [activeTab]);

  const handleAddModule = (moduleObj) => {
    const currModuleList = [...selectedModules[activeTab]];
    const currIndex = currModuleList.findIndex((m) => m.module === moduleObj.key);
    if (currIndex === -1) {
      currModuleList.push({
        module: moduleObj.key,
        enabledDevices: {
          webApp: true,
          mobile: false,
          tablet: false,
        },
      });
    } else {
      currModuleList.splice(currIndex, 1);
    }

    setSelectedModules({ [activeTab]: currModuleList });
  };

  const handleNext = () => {
    if (activeTab === HOTEL_SERVICES) {
      setActiveTab(GUEST_ROOM_EXP);
      return;
    }

    if (activeTab === GUEST_ROOM_EXP) {
      setActiveTab(ENTERTAINMENT);
      return;
    }

    if (activeTab === ENTERTAINMENT) {
      onLastNextClick(selectedModules);
      return;
    }
  };

  return (
    <div>
      <div className='d-flex mt-4 justify-content-between'>
        <div className='sub-title'>Select Modules</div>
        <div className='gray-text text-right'>
          {selectedModules[HOTEL_SERVICES].length +
            selectedModules[GUEST_ROOM_EXP].length +
            selectedModules[ENTERTAINMENT].length}{' '}
          Selected
        </div>
      </div>
      <div className='row d-flex mt-4'>
        <div className='card shadow module-select'>
          <div className='d-flex my-4 justify-content-center'>
            {Object.keys(HOTEL_SYSTEMS_TITLES).map((section, i) => (
              <Button
                key={i}
                size='large'
                variant={activeTab === section ? 'outlined' : 'text'}
                className={activeTab === section ? classes.activeButton : classes.button}
                onClick={() => setActiveTab(section)}
              >
                {HOTEL_SYSTEMS_TITLES[section]}
              </Button>
            ))}
          </div>
          <div className='text-center gray-text mb-4'>
            Tap on below tiles to select the particular module
          </div>
          <div className='mx-auto w-75 mb-5'>
            <ModulesList
              moduleList={moduleList}
              selectedModules={selectedModules}
              activeTab={activeTab}
              handleAddModule={handleAddModule}
            />
          </div>
          <div className='row mx-2 mt-auto px-4 w-100 pb-5 justify-content-center'>
            <Button
              className='next-btn'
              size='large'
              color='primary'
              variant='contained'
              onClick={() => handleNext()}
            >
              <ArrowForward fontSize='large' />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleSelect;
